import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
export const WEB_SOURCE_ICON = $icon('world');
export const CONNECTOR_SOURCE_ICON = $icon('plug');
export const MEMORY_SEARCH_ICON = $icon('clock-search');
export const FILE_SOURCE_ICON = $icon('file');
export const WORKSPACE_FILES_SOURCE_ICON = $icon('folders');
//# sourceMappingURL=sourceIcons.js.map